import { h } from 'preact'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'

const TopicFavorite = ({ className = '', isActive, onCallback }: { className?: string, isActive: boolean, onCallback: () => void }) => {
  return (
    <li className={`post__action-item qa-link-subscribe ${isActive ? 'is-active' : ''} ${className}`} onClick={onCallback}>
      <Icon
        icon={isActive ? 'star' : 'starBorder'}
        size={16}
      />
      <span className='post-footer-item-text'><Phrase p='Subscribe' /></span>
    </li>
  )
}

export default TopicFavorite
